<template>
    <div class="app_detail">
        <titleBar :title="title"></titleBar>
        <productDetail 
          :productData="productData"
          @selectTime="handleSelectTime"></productDetail>
        <div class="footer">
            <div v-if="productData.buttonStatus == 3" class="purchase_0">
                <div @click="payEvent(productData.oldProductId,true)">
                    <span>¥{{productData.originPrice}}</span> 
                    <span>原价购买</span>
                </div>
                <div @click="payEvent(productData.productId,false)">
                    <span>¥{{productData.groupPrice}}</span> 
                    <span>我要开团</span>
                </div>
            </div>
            <div class="purchase_1" v-if="productData.buttonStatus == 6" @click="toGroup">拼团成功，查看我的团</div>
            <div class="purchase_1" v-if="productData.buttonStatus == 5" @click="toGroup">已发起拼团，查看我的团</div>            
            <div class="purchase_2" v-if="productData.buttonStatus == 1">活动未开始</div>
            <div class="purchase_3" v-if="productData.buttonStatus == 2">活动已结束</div>
            <div class="purchase_3" v-if="productData.buttonStatus == 4">已购买</div>
        </div>  
    </div>
</template>

<script>
import titleBar from "@/components/common/titleBar.vue";
import utils from "@/assets/js/utils";
import { MOBILE_API } from "@/constants/api";
import productDetail from "./components/product_detail.vue";

let vm = null;
window.callback = function(obj) {
  vm.orderAdd(JSON.parse(obj));
};
window.onVisible = function() {
  vm.initData();
};
export default {
  name: "app_detail",
  data() {
    return {
      title: "活动详情",
      token: "",
      source: "", //客户端来源
      groupInfoId: "", //团购产品id
      groupId: 0, //团购id
      phaseId: 0, //年级
      orderId: 123, //团购订单id
      successUrl: "", //购买成功页
      currProductId: "", //当前下单产品ID
      productData: {}, //产品信息
      isOrignProduct: "", //是否是原价购买
      department: "" //1小盒编程 2小盒古诗 3小盒科学 4布克听世界
    };
  },
  components: {
    productDetail,
    titleBar
  },
  methods: {
    initData() {
      const { token, source, groupInfoId, groupId, version } = this;
      this.$api
        .getProductDetail({
          token,
          source,
          groupInfoId,
          groupId
        })
        .then(data => {
          utils.sendLog(
            {
              token: token,
              version: version,
              source: source,
              extensionJson: {
                tuangou_status: data.buttonStatus,
                tuangou_productId: groupInfoId,
                pageChannel: this.pageChannel
              }
            },
            "hzxx847"
          );
          this.productData = data;
          // this.productData = { "courseTimes": [{"phaseId":"3","time": "333"}],"buttonStatus":6,"groupId":"40","department":"4","productId":"2118","oldProductId":"1410","groupName":"sj-布克听世界","groupDesc":"sj-布克听世界拼团课程副标题sj-布克听世界拼团课程副标题sj-布克听世界拼团课程副标题sj-布克听世界拼团课程副标题sj-布克听世界拼团课程副标题","buyerCount":"4","groupPrice":"33.00","originPrice":"12.00","groupRule":["规则显示如下：sj的布克听世界团购开团了sj的布克听世界团购开团了sj的布克听世界团购开团了sj的布克听世界团购开团了sj的布克听世界团购开团了"],"groupDescImgList":["https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg","http://ofyjiu406.bkt.clouddn.com/750-750.jpg"],"serviceList":[{"title":"server-two","desc":"server-twoserver-twoserver-twoserver-two"}],"groupNumber":695,"grade":"一年级","groupInfo":{"groupStatus":"2","headList":["https://appd.knowbox.cn/ss/images/defaultImg/knowboxgirl.jpg","http://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTLQnxhSMxaLcatUfE9s2D1JoNhrA6IjwQDicCaQoKBNhA5cIWfgy4QqUb8lxsJlfxD4EzIGOQCiby8Q/132","http://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTLIKM3X4QRt4YHh78aShsFH4K8sZMznDJAELyic6xtHQfyVSBnG08r6a38WcpccWBaxmX5YjpBTX2w/132","http://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTLQnxhSMxaLcatUfE9s2D1JoNhrA6IjwQDicCaQoKBNhA5cIWfgy4QqUb8lxsJlfxD4EzIGOQCiby8Q/132"],"groupProducer":"**","headUrl":"https://appd.knowbox.cn/ss/images/defaultImg/knowboxgirl.jpg","endTime":0,"courseTime":"","leftPeopleNumber":0,"orderCount":4},"headPhotoUrl":"http://ofyjiu406.bkt.clouddn.com/750-750.jpg","bubbleList":[{"username":"测**","headPhoto":"https://appd.knowbox.cn/ss/images/defaultImg/knowboxgirl.jpg"},{"username":"游**","headPhoto":"https://appd.knowbox.cn/ss/images/defaultImg/knowboxgirl.jpg"},{"username":"x**","headPhoto":"http://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTIabXmbnnQoaCEF7JYW68n4L799defZf9dNZzaRtpXw4ibxYCJJ4a4fyd0TIonmibdqV0S9Gsp7C3EQ/132"},{"username":"桂**","headPhoto":"https://appd.knowbox.cn/ss/images/defaultImg/knowboxgirl.jpg"},{"username":"**","headPhoto":"https://appd.knowbox.cn/ss/images/defaultImg/knowboxgirl.jpg"},{"username":"s**","headPhoto":"http://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTLQnxhSMxaLcatUfE9s2D1JoNhrA6IjwQDicCaQoKBNhA5cIWfgy4QqUb8lxsJlfxD4EzIGOQCiby8Q/132"},{"username":"k**","headPhoto":"http://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTLIKM3X4QRt4YHh78aShsFH4K8sZMznDJAELyic6xtHQfyVSBnG08r6a38WcpccWBaxmX5YjpBTX2w/132"},{"username":"l**","headPhoto":"http://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTLQnxhSMxaLcatUfE9s2D1JoNhrA6IjwQDicCaQoKBNhA5cIWfgy4QqUb8lxsJlfxD4EzIGOQCiby8Q/132"},{"username":"æ**","headPhoto":"http://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEKj6iaLTOzYGiaDNlApGv99ib3FOLTwNt9CvAn5recSpKcYJRlevoFwnojN3E1RslJXyB3oUIGwWFwJA/132"},{"username":"**","headPhoto":"https://appd.knowbox.cn/ss/images/defaultImg/knowboxgirl.jpg"}],"shareImgUrl":"http://ofyjiu406.bkt.clouddn.com/750-750.jpg","shareTitle":"大家都来拼团吧","shareDesc":"这个是布克听世界的拼团，sj的布克听世界团购开团了，sj的布克听世界团购开团了，sj的布克听世界团购开团了","needLogin":0};//产品信息
          this.phaseId =
            data.courseTimes.length !== 0 ? data.courseTimes[0].phaseId : 0;
          this.groupId = data.groupId;
          this.department = data.department;
          localStorage.setItem("token", this.token);
          localStorage.setItem("shareImgUrl", data.shareImgUrl);
          localStorage.setItem("shareTitle", data.shareTitle);
          localStorage.setItem("shareDesc", data.shareDesc);
          this.successUrl =
            window.location.origin +
            window.location.pathname +
            "#/group_buy/group_detail?hideTitleBar=1" +
            "&token=" +
            this.token +
            "&groupInfoId=" +
            this.groupInfoId +
            "&groupId=" +
            this.groupId +
            "&source=" +
            this.source +
            "&version=" +
            this.version +
            "&department=" +
            this.department;
          console.log("========initData============", this.successUrl);
        })
        .catch(res => {
          this.$toast(res.msg);
        });
    },
    orderAdd(obj) {
      const {
        token,
        source,
        version,
        groupInfoId,
        groupId,
        phaseId,
        currProductId,
        pageChannel
      } = this;
      this.$api
        .orderAdd({
          token,
          source,
          version,
          pageChannel,
          productId: currProductId,
          groupInfoId,
          groupId,
          phaseId,
          identity: "parent",
          userSource: "NEW-PARENT-GROUP-BUYING",
          openid: "",
          mobile: "",
          nickname: "",
          headPhoto: "",
          clientChannel: obj.channel,
          clientVersion: obj.appVersion,
          deviceBrand: obj.platform,
          deviceModel: obj.platform,
          OSName: obj.platform,
          OSVersion: obj.deviceVersion
        })
        .then(data => {
          this.orderId = data.orderId;
          console.log(this.isOrignProduct, "this.isOrignProduct");
          if (this.isOrignProduct) {
            switch (this.department) {
              case "1":
                //小象编程前端域名
                const eleDomain = {
                  dev: "https://qacode3.knowbox.cn/",
                  test: "https://qacode3.knowbox.cn/",
                  preview: "https://code.knowbox.cn/",
                  production: "https://code.knowbox.cn/"
                };
                this.successUrl =
                  eleDomain[process.env.VUE_APP_INTER] +
                  "/activity/activitypage/appnewsuccess.html?appxhktToken=" +
                  encodeURIComponent(token);
                break;
              case "2":
                this.successUrl = MOBILE_API.myclass;
                break;
              case "3":
                this.successUrl = MOBILE_API.myclass;
                break;
              case "4":
                this.successUrl = MOBILE_API.openBukeListeningHomePage;
                break;
              case "5":
                this.successUrl = MOBILE_API.myclass;
                break;
              default:
                break;
            }
          }
          console.log("=========orderAdd===========", this.successUrl);
          let publicPath = {
            dev: "https://qa.knowbox.cn:8004",
            test: "https://qa.knowbox.cn:8004",
            preview: "https://preshark.knowbox.cn:8044",
            production: "https://stuapi.knowbox.cn"
          };
          window.location =
            "hybird://method/buyGroupCourse?orderId=" +
            this.orderId +
            "&payHost=" +
            escape(publicPath[process.env.VUE_APP_INTER]) +
            "&orderInfoPath=group-buying/pay/order-info&successUrl=" +
            escape(this.successUrl) +
            "&chargePath=group-buying/pay/order-add-pay-obj&verifyPath=group-buying/pay/order-verify&orderSource=app";
        })
        .catch(res => {
          this.$toast(res.msg);
        });
    },
    handleSelectTime({ id }) {
      this.phaseId = id;
    },
    toGroup() {
      utils.sendLog(
        {
          token: this.token,
          version: this.version,
          source: this.source,
          extensionJson: {
            tuangou_status:  this.productData.buttonStatus,
            tuangou_productId: this.groupInfoId,
            pageChannel: this.pageChannel
          }
        },
        "hzxx848"
      );      
      window.location.href = this.successUrl;
    },
    payEvent(productId, isOrignProduct) {
      utils.sendLog(
        {
          token: this.token,
          version: this.version,
          source: this.source,
          extensionJson: {
            tuangou_status: isOrignProduct? 8: this.productData.buttonStatus,
            tuangou_productId: this.groupInfoId,
            pageChannel: this.pageChannel
          }
        },
        "hzxx848"
      );
      this.currProductId = productId;
      this.isOrignProduct = isOrignProduct;
      // let obj = '{"deviceVersion":"11.0.1","version":"332","channel":"AppStore","buildVersion":"3.3.3.1","deviceId":"563E7F43-6399-440C-99E6-F163A95DA408","source":"iOSRCParent","deviceType":"iOSx8664Simulator","packageName":"com.appKnowin.PRapidCalculation","platform":"iOS","appName":"RCParent","token":"MxTARa2dBPmM5QtYb1mdLkoZ_xmE6rNau_v653LR9hPc0k7zbqmdHiYesG9kI0SFK4DGaFPsMpiEUTnF3Ij0D4SO-Dx4JUwqF02DC86hg_o\/","mode":0,"appVersion":"3.3.2"}'
      // vm.orderAdd(JSON.parse(obj));
      window.location = "hybird://method/nativeToJS?funcName=callback";
    }
  },
  created: function() {
    vm = this;
    this.token = utils.getQueryString("token");
    this.source = utils.getQueryString("source");
    this.version = utils.getQueryString("version");
    this.groupInfoId = utils.getQueryString("groupInfoId");
    this.pageChannel = utils.getQueryString("pageChannel");
    localStorage.setItem('pageChannel',this.pageChannel);
    this.initData();
    console.log('window.location.href',window.location.href)
  }
};
</script>

<style scoped lang="scss">
.app_detail {
  margin-top: 0.88rem;
  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1rem;
    .purchase {
      &_0 {
        display: flex;
        height: 1rem;
        div {
          &:nth-child(1) {
            background: #fff;
            width: 2.7rem;
            font-size: 0.24rem;
            color: #919294;
            font-family: PingFangSC-Medium;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            span:nth-child(1) {
              font-size: 0.36rem;
              color: #ff7575;
              height: 0.4rem;
            }
          }
          &:nth-child(2) {
            font-size: 0.24rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background-color: #ff5c5c;
            width: 4.8rem;
            color: #ffffff;
            span:nth-child(1) {
              font-size: 0.36rem;
              height: 0.4rem;
            }
          }
        }
      }
      &_1 {
        height: 1rem;
        line-height: 1rem;
        text-align: center;
        background-color: #ff5c5c;
        font-family: PingFangSC-Medium;
        font-size: 0.34rem;
        color: #ffffff;
      }
      &_2 {
        height: 1rem;
        line-height: 1rem;
        text-align: center;
        background-color: #fff;
        font-family: PingFangSC-Medium;
        font-size: 0.34rem;
        color: #ff5c5c;
      }
      &_3 {
        height: 1rem;
        line-height: 1rem;
        text-align: center;
        background-color: #d2d3d4;
        font-family: PingFangSC-Medium;
        font-size: 0.34rem;
        color: #fff;
      }
    }
  }
}
/*iPhone X XS 2436x1125px at 458ppi */
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .app_detail {
    .footer {
      height: 1.4rem;
      .purchase {
        &_0 {
          display: flex;
          height: 1.4rem;
        }
        &_1 {
          height: 1.4rem;
        }
        &_2 {
          height: 1.4rem;
        }
        &_3 {
          height: 1.4rem;
        }
      }
    }
  }
}

/*iPhone XR 1792x828px at 326ppi */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
  .app_detail {
    .footer {
      height: 1.4rem;
      .purchase {
        &_0 {
          display: flex;
          height: 1.4rem;
        }
        &_1 {
          height: 1.4rem;
        }
        &_2 {
          height: 1.4rem;
        }
        &_3 {
          height: 1.4rem;
        }
      }
    }
  }
}

/* iPhone XS Max 2688x1242px at 458ppi */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
  .app_detail {
    .footer {
      height: 1.4rem;
      .purchase {
        &_0 {
          display: flex;
          height: 1.4rem;
        }
        &_1 {
          height: 1.4rem;
        }
        &_2 {
          height: 1.4rem;
        }
        &_3 {
          height: 1.4rem;
        }
      }
    }
  }
}
</style>